import { render, staticRenderFns } from "./driverDetail.vue?vue&type=template&id=5cc11d4f&scoped=true"
import script from "./driverDetail.vue?vue&type=script&lang=js"
export * from "./driverDetail.vue?vue&type=script&lang=js"
import style0 from "./driverDetail.vue?vue&type=style&index=0&id=5cc11d4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc11d4f",
  null
  
)

export default component.exports